import _ from 'lodash'

export const addUrlProtocols = (url: string): string => {
	const protocols = ['https://', 'http://', '//']
	const hasProtocol = _.some(protocols, _.includes.bind(null, url))
	return hasProtocol ? url : _.last(protocols) + url
}
